import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, Grid, Typography } from "@mui/material";
import { getWarehouses } from "../../Services/inventoryService";
import { getUsers } from "../../Services/userService";
import { KEY_CUSTOMER } from "../../Constants/KeyConstant";

const DeliveryDestination: React.FC<{ orgId:string, deliveryType: string }> = ({ orgId,deliveryType }) => {
  const [warehouses, setWarehouses] = useState<any[]>([]);
  const [customers, setCustomers] = useState<any[]>([]);
  const [selectedDestination, setSelectedDestination] = useState<any>(null);
  useEffect(() => {
    setSelectedDestination(null);
    if (deliveryType === KEY_CUSTOMER) {
      fetchCustomers();
    } else {
      fetchWarehouses();
    }
  }, [deliveryType]);

  const fetchWarehouses = async () => {
    try {
       if (!orgId) return;
      const data = await getWarehouses(orgId);
      setWarehouses(data);
    } catch (error) {
      console.error("Error fetching warehouses:", error);
    }
  };

  const fetchCustomers = async () => {
    try {
       if (!orgId) return;
      const customerData = await getUsers(orgId, KEY_CUSTOMER);
      const customersList = customerData?.map((customer: any) => ({
        id: customer.Id,
        name:
          customer?.customerName ??
          (customer?.companyName ||
            [customer?.firstName, customer?.lastName].filter(Boolean).join(" ")),
        email: customer?.email || "",
        GSTIN: customer?.GSTIN || "",
        phone: customer?.phone || "",
        address: {
          street: customer?.address?.street || "",
          city: customer?.address?.city || "",
          state: customer?.address?.state || "",
          zipCode: customer?.address?.zipCode || "",
          country: customer?.address?.country || "",
        },
        companyName: customer?.companyName || "",
      }));
      setCustomers(customersList);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  return (
    <>
      {deliveryType === KEY_CUSTOMER ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              options={customers}
              getOptionLabel={(option) => option.name}
              value={selectedDestination}
              onChange={(e, value) => setSelectedDestination(value)}
              renderInput={(params) => (
                <TextField {...params} label="Select Customer" fullWidth />
              )}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Stock on Hand will not be affected only in case of dropshipments.
              Selecting the Customer option will affect your stock level.
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Autocomplete
              options={warehouses}
              getOptionLabel={(option) => option.warehouseName}
              value={selectedDestination}
              onChange={(e, value) => setSelectedDestination(value)}
              renderInput={(params) => (
                <TextField {...params} label="Select Warehouse" fullWidth />
              )}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default DeliveryDestination;
